/* eslint-disable global-require */
import { FC, memo, MouseEventHandler } from 'react';
import cn from '../../utils/classnames';
import './icon.scss';

type IconProps = {
    name: string;
    active?: boolean;
    animated?: boolean;
    className?: string;
    height?: number;
    onClick?: MouseEventHandler<HTMLSpanElement>;
    size?: '' | 'sm';
    text?: string;
    width?: number | string;
    testId?: string;
};

const Icon: FC<IconProps> = (props) => {
    const {
        size = '',
        animated = true,
        width = 'auto',
        className = '',
        text = '',
        name,
        active = false,
        height = 26,
        onClick
    } = props;

    return (
        <span
            className={cn(
                `custom-icon ${name}-icon`,
                {
                    active,
                    animated
                },
                className
            )}
            onClick={onClick}
            data-testid={props.testId}
        >
            <>
                <img
                    alt=''
                    className='default'
                    height={height}
                    width={width}
                    src={require(`./${name}/${name}${size ? `.${size}` : ''}.svg`)}
                />
                {(animated || active) && (
                    <img
                        alt=''
                        className='colored'
                        height={height}
                        width={width}
                        src={require(`./${name}/${name}${size ? `.${size}` : ''}.colored.svg`)}
                    />
                )}
            </>
            {text && <span className='text'>{text}</span>}
        </span>
    );
};

export default memo(Icon);
